
<template>
    <div v-if="basket.items.length && order && order.status === 'created'" class="checkout" v-on:change="validate">
        <header>
            <a v-on:click="back" class="del"><span class="icon-left"></span> Continue shopping</a>
            <h1>Checkout</h1>
            <span class="del"><span class="icon-padlock"></span> Secure checkout</span>
        </header>

        <div class="center">
            <label>
                Email address *
                <input class="input" v-model="order.account" type="text"/>
            </label>

            <label>
                Telephone *
                <input class="input" v-model="order.telephone" type="text"/>
            </label>

            <section>
                <h2>Billing address</h2>

                <label>
                    Full name *
                    <input class="input" v-model="order.billing_fullname" type="text"/>
                </label>

                <label>
                    Address 1 *
                    <input class="input" v-model="order.billing_line1" type="text"/>
                </label>

                <label>
                    Address 2
                    <input class="input" v-model="order.billing_line2" type="text"/>
                </label>

                <label>
                    City *
                    <input class="input" v-model="order.billing_city" type="text"/>
                </label>

                <label>
                    County
                    <input class="input" v-model="order.billing_county" type="text"/>
                </label>

                <div class="columns">
                    <label class="column">
                        Postcode *
                        <input class="input" v-model="order.billing_postcode" type="text"/>
                    </label>

                    <label class="column">
                        Country *
                        <select class="select" v-model="order.billing_country">
                            <option v-for="country in countries" :value="country.code">{{ country.name }}</option>
                        </select>
                    </label>
                </div>
            </section>

            <label class="checkbox">
                <input type="checkbox" class="checkbox" v-model="order.collection"/>
                I want to collect this order
            </label>

            <label class="checkbox" v-if="!order.collection && order.canShipToBilling">
                <input type="checkbox" class="checkbox" v-model="order.ship_to_billing"/>
                Ship to this address also
            </label>

            <section v-if="!order.collection && ! order.shipToBilling">
                <h2>Shipping address</h2>

                <label>
                    Full name *
                    <input class="input" v-model="order.shipping_fullname" type="text"/>
                </label>

                <label>
                    Address 1 *
                    <input class="input" v-model="order.shipping_line1" type="text"/>
                </label>

                <label>
                    Address 2
                    <input class="input" v-model="order.shipping_line2" type="text"/>
                </label>

                <label>
                    City *
                    <input class="input" v-model="order.shipping_city" type="text"/>
                </label>

                <label>
                    County
                    <input class="input" v-model="order.shipping_county" type="text"/>
                </label>

                <div class="columns">
                    <label class="column">
                        Postcode *
                        <input class="input" v-model="order.shipping_postcode" type="text"/>
                    </label>

                    <label class="column">
                        Country *
                        <input class="input" :value="uk" type="text" readonly/>
                    </label>
                </div>
            </section>

            <h2>Payment method</h2>

            <label>
                Card number *
                <div ref="card"></div>
            </label>
        </div>

        <p v-if="error" class="text-center is-bold">{{ error }}</p>
        <button type="button" class="button is-primary is-fullwidth" :disabled="!valid" v-on:click="process" :class="{ 'is-loading': processing }">Pay {{ currency( order.collection ? basket.subtotal : basket.total ) }}</button>
    </div>
    <div v-else-if="order && order.status === 'paid'" class="checkout">
        <h1>Thank you for your order</h1>
        <p class="is-bold">Order number: {{ order.order_id }}</p>
        <p>You will receive email confirmation shorty</p>
        <button type="button" v-on:click="back" class="button is-primary spacer">Continue shopping</button>
    </div>
    <div v-else-if="!loading" class="checkout">
        <p>No items in your basket.</p>
        <button type="button" v-on:click="back" class="button is-primary spacer">Continue shopping</button>
    </div>
</template>

<script>
	import countries from '../support/countries'
    import session from '../support/Session';
    import Basket from '../models/Basket';
	import currency from '../support/Currency';
    import StripeGateway from '../support/StripeGateway';

	export default
    {
    	computed:
        {
            basket()
            {
            	return this.session.basket;
            },
        },
        data()
        {
	        const country = countries.find( country => country.code === 'GB' );

        	return {
		        uk: country.name,
                session,
                countries,
                error: null,
                valid: false,
                loading: true,
                order: null,
		        processing: false,
                stripe: new StripeGateway,
            };
        },
        methods:
        {
        	back()
            {
                const shoot_id = session.get( 'shoot_id' );
                if( shoot_id === null ) {
	                this.$router.push( { name: 'shoots' } );
                } else {
	                this.$router.push( { name: 'shoot', params: { id: shoot_id } } );
                }
            },
	        validate()
            {
            	return this.valid = this.order.validate();
            },
        	/**
             * Process order
             * @returns {Promise}
             */
            process()
            {
            	if( this.processing )
            		return;

            	this.processing  = true;
            	if( this.validate() ) {
		            return this.stripe.process( this.order ).then( order => {
			            this.order = order;
			            this.session.delete( 'basket_id' );
		            	this.session.basket = new Basket;
			            this.processing = false;
		            }, error => {
		            	this.error = error;
		            	this.processing = false;
		            });
                }
            },
            currency,
        },
        mounted()
        {
        	this.$root.basketOpen = false;

        	const vue = this;
            if( ! this.basket.items.length )
                this.$router.push( { name: 'shoots' } );

            this.basket.order().then( order => {
                this.loading = false;
                vue.order = order;
                vue.$nextTick( () => {
                    vue.stripe.mount( vue.$refs.card );
                });
            }, error => {
                this.$router.push( { name: 'shoots' } );
            });
        }
	};
</script>
